import { Input as SemanticInput } from 'semantic-ui-react';

export { InputProps, StrictInputProps, InputOnChangeData } from 'semantic-ui-react';

export const Input: typeof SemanticInput = SemanticInput;

export default Input;
